<template>
  <div class="space-y-8">
    <ContactListStats :contact-list="contactList" />
  </div>
</template>

<script>
import ContactListStats from './components/ContactListStats.vue';

export default {
  components: {
    ContactListStats,
  },
  props: {
    contactList: {
      type: Object,
      required: true,
    },
  },
};
</script>
